import { Topic } from "shared/types";

const targetingArguments = (data: Topic) => ({
  env: process.env.NEXT_PUBLIC_ENVIRONMENT,
  tid: data.id,
  cid: data.category && data.category.id,
  mtid: data.tag && data.tag.id,
  mt: "p",
});

export const AdUnitProps = {
  adTypes: {
    adsense: {
      pageTop: (data: Topic) => ({
        adUnit: "21677603197/sp_topic_top",
        sizes: [
          [300, 250],
          [336, 280],
        ],
        targetingArguments: targetingArguments(data),
      }),
      pageMiddle: (data: Topic) => ({
        adUnit: "21677603197/sp_topic_middle",
        sizes: [
          [300, 250],
          [336, 280],
        ],
        targetingArguments: targetingArguments(data),
      }),
      pageBottom: (data: Topic) => ({
        adUnit: "21677603197/sp_topic_bottom",
        sizes: [
          [300, 250],
          [336, 280],
        ],
        targetingArguments: targetingArguments(data),
      }),
      pageBottomSecondary: (data: Topic) => ({
        adUnit: "21677603197/sp_topic_bottom2",
        sizes: [
          [300, 250],
          [336, 280],
        ],
        targetingArguments: targetingArguments(data),
      }),
    },
    not_adsense: {
      pageTop: (data: Topic) => ({
        adUnit: "21677603197/sp_topic_top_ng",
        sizes: [
          [300, 250],
          [336, 280],
        ],
        targetingArguments: targetingArguments(data),
      }),
      pageMiddle: (data: Topic) => ({
        adUnit: "21677603197/sp_topic_middle_ng",
        sizes: [
          [300, 250],
          [336, 280],
        ],
        targetingArguments: targetingArguments(data),
      }),
      pageBottom: (data: Topic) => ({
        adUnit: "21677603197/sp_topic_bottom_ng",
        sizes: [
          [300, 250],
          [336, 280],
        ],
        targetingArguments: targetingArguments(data),
      }),
      pageBottomSecondary: (data: Topic) => ({
        adUnit: "21677603197/sp_topic_bottom2_ng",
        sizes: [
          [300, 250],
          [336, 280],
        ],
        targetingArguments: targetingArguments(data),
      }),
    },
  },
  forAds: {
    pageTop: (data: Topic) => ({
      adUnit: "21677603197/sp_topic_top_2",
      sizes: [
        [300, 250],
        [336, 280],
      ],
      targetingArguments: targetingArguments(data),
    }),
    pageMiddle: (data: Topic) => ({
      adUnit: "21677603197/sp_topic_middle_2",
      sizes: [
        [300, 250],
        [336, 280],
      ],
      targetingArguments: targetingArguments(data),
    }),
    pageBottom: (data: Topic) => ({
      adUnit: "21677603197/sp_topic_middle_3",
      sizes: [
        [300, 250],
        [336, 280],
      ],
      targetingArguments: targetingArguments(data),
    }),
  },
};
